import { Icon } from '@hover/blueprint';
import { iMinimize } from '@hover/icons';
import React from 'react';

import { useRenderingContext } from 'src/modules/renderings/hooks';
import { Button } from 'src/shared/components';

interface MinimizeButtonProps {
  onClick: () => void;
}

const MinimizeButton = ({ onClick }: MinimizeButtonProps) => {
  const { trackingData } = useRenderingContext();

  return (
    <Button
      _hover={{ transform: 'scale(1.1)' }}
      backgroundColor="neutral.0"
      data-group
      label="full-screen-icon"
      onClick={onClick}
      optionalTrackingProperties={{
        ...trackingData,
        track_id: 'rendering-focused-view',
      }}
      shadow="distance100"
      shape="circle"
      transitionDuration="350ms"
      transitionProperty="all"
      transitionTimingFunction="ease-out"
    >
      <Icon
        _groupHover={{ color: 'neutral.0' }}
        color="neutral.900"
        icon={iMinimize}
      />
    </Button>
  );
};

export { MinimizeButton };
